export default __webpack_public_path__ + "static/char-s-02-en-751da79265f522800521f52913979bb2.webp";